import { InjectionToken } from "@angular/core";
import { ProductKey } from "gast-common-ng2";

export const PORTAL_DEFAULT_PRODUCT_TOKEN = new InjectionToken<ProductKey>("PORTAL_DEFAULT_PRODUCT_TOKEN");
